import { render, staticRenderFns } from "./D2PRMD0040.vue?vue&type=template&id=1b98d55b&scoped=true&"
import script from "./D2PRMD0040.js?vue&type=script&lang=js&"
export * from "./D2PRMD0040.js?vue&type=script&lang=js&"
import style0 from "./D2PRMD0040.vue?vue&type=style&index=0&id=1b98d55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98d55b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VCol,VContainer,VIcon,VRadio,VRadioGroup,VRow,VSpacer})
